
/**
 * Value object containing resulting hint to the question with everything needed 
 * to display that hint. Used only for DTO
 * 
 * @param boolean found Is set true if this is a found hint
 * @param string content Actual content
 * @param array numbers Numbers associated to this string
 * @return this
 */
var Hint = function ( found ) {
  
  var hintFound = found ? true : false;

  var answerFromLinkId = '';
  var answerValueString = '';
  var answerValueBoolean = false;
  var hintComment = '';
  var hintDestinationId = '';

  return {
    
    /**
     * Return 
     * 
     * @return boolean
     */
    hintFound : function(){
      return hintFound;
    },


    /**
     * - 
     * 
     * @param string srcId
     * @return void
     */
    setSourceId : function( srcId ){
      answerFromLinkId = srcId;
      hintFound = true;
    },


    /**
     * - 
     * 
     * @param string srcId
     * @return void
     */
    setValueBoolean : function( val ){
      answerValueBoolean = val;
      hintFound = true;
    },


    /**
     * - 
     * 
     * @param string srcId
     * @return void
     */
    setValueString : function( val ){
      answerValueString = val;
      hintFound = true;
    },


    /**
     * - 
     * 
     * @return void
     */
    setHintComment : function( comment ){
      hintComment = comment;
    },


    /**
     * - 
     * 
     * @return void
     */
    setDestinationId : function( destId ){
      hintDestinationId = destId;
    },

    
    /**
     * - 
     * 
     * @return boolean
     */
    getValueBoolean : function(){
      return answerValueBoolean;
    },


    /**
     * - 
     * 
     * @return string
     */
    getValueString : function(){
      return answerValueString;
    },


    /**
     * - 
     * 
     * @return void
     */
    getHintComment : function(){
      return hintComment;
    },

    
    /**
     * What question resulted this hint
     * 
     * @return boolean
     */
    getSourceId : function(){
      return answerFromLinkId;
    },

    
    /**
     * What question answer is hinted by this hint
     * 
     * @return boolean
     */
    getDestinationId : function(){
      return hintDestinationId;
    },
    

    /**
     * Are comparable instances true? 
     * 
     * @return boolean
     */
    isEqual : function( otherHint ){
      
      if( otherHint.hintFound() !== hintFound ){
        return false;
      }

      if( otherHint.getSourceId() !== answerFromLinkId ){
        return false;
      }

      if( otherHint.getValueString() !== answerValueString ){
        return false;
      }

      if( otherHint.getValueBoolean() !== answerValueBoolean ){
        return false;
      }

      if( otherHint.getHintComment() !== hintComment ){
        return false;
      }
      
      return true;
    }
    
  };

};

export default Hint;